module.exports = __webpack_public_path__ + "static/product_service_bg@2x-45875510db55f70199f310478c110f0e.png";